<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <tabela
          :loading="loading"
          :items="items"
          :ultimoRegistroOficial="ultimoRegistroOficial"
          :ultimoRegistroNaoOficial="ultimoRegistroNaoOficial"
          @rechargeTable="getAll()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AtualizacaoIndices from '@/services/AtualizacaoIndicesService.js';
  import pusherMixins from '@/mixins/pusherMixins';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Tabela: () => import('@/components/atualizacaoIndices/Tabela.vue')
    },
    mixins: [pusherMixins, tourMixins],

    data: () => ({
      items: [],
      ultimoRegistroOficial: '',
      ultimoRegistroNaoOficial: '',
      arrTour: [
        {
          element: '#btn-novo-indice-ipca',
          intro: 'Clicando neste botão você poderá cadastrar novos Índices IPCA.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#btn-novo-indice-ipca-estimado',
          intro: 'Clicando neste botão você poderá cadastrar novos Índices IPCA Estimados.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#indie-icpca-search',
          intro: 'Neste campo você poderá pesquisar por índices já cadastrados.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#btn-edit-indice-ipca',
          intro:
            'Clicando neste botão você será redirecionado para a tela de edição, onde será possível editar o ultimo índice cadastrado.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#btn-excluir-indice-ipca',
          intro: 'Clicando neste botão será possível excluir o ultimo índice cadastrado.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ],
      loading: false
    }),

    mounted() {
      this.getAll();
      this.subscribe();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('reload-pag-atualizacao-indices', () => {
          this.getAll();
        });
      },

      getAll() {
        ((this.loading = true),
          AtualizacaoIndices.getAllIndices()
            .then((rData) => {
              this.items = rData.indices;
              this.ultimoRegistroOficial = rData.ultimoRegistroOficial;
              this.ultimoRegistroNaoOficial = rData.ultimoRegistroNaoOficial;
            })
            .catch((err) => {
              console.log('Erro: ', err);
              this.$toast.error('Erro buscar Indices.', '', { position: 'topRight' });
            })
            .finally(() => {
              ((this.loading = false), this.iniciarTourPagina());
            }));
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>